// removed by extract-text-webpack-plugin
module.exports = {"link":"_2qHCb","icon":"_3gTzf"};